export interface PaginationQuery {
  pageSize: number;
  page: number;
}

export interface Pagination {
  total?: number;
  page: number;
  type?: "primary" | "secondary";
  limit?: number;
  itemNum?: number;
  hasNextPage?: boolean;
}

export interface Money {
  value: number;
  currencyCode: string;
}

export enum IsSameAddress {
  YES = "YES",
  NO = "NO",
}

export enum IsDeliveryToAddress {
  YES = "YES",
  NO = "NO",
}

export enum IsSignUp {
  YES = "YES",
  NO = "NO",
}

export enum Checkbox {
  YES = "YES",
  NO = "NO",
}

export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType extends readonly (infer ElementType)[]
  ? ElementType
  : never;

export type FindItem = {
  Id: string;
  Type: "Address" | "Container";
  Text: string;
  Highlight: string;
  Description: string;
};

export type RetrieveItem = {
  SubBuilding: string;
  BuildingNumber: string;
  BuildingName?: string;
  Street: string;
  City: string;
  PostalCode: string;
  [key: string]: any; // Allow other properties
};

export type VerifyAddressInput = { Country: string; PostalCode: string; Locality: string; Address: string };

export type LoqateVerifyMatch = {
  Address: string;
  Address1: string;
  Address2: string;
  Company?: string;
  DeliveryAddress: string;
  DeliveryAddress1: string;
  AdministrativeArea: string;
  SubAdministrativeArea: string;
  Locality: string;
  Thoroughfare: string;
  Building?: string;
  BuildingName?: string;
  Premise: string;
  SubBuilding: string;
  PostalCode: string;
  CountryName: string;
  "ISO3166-2": string;
  "ISO3166-3": string;
  "ISO3166-N": string;
  PostalCodePrimary: string;
  AVC: string;
  AQI: string;
  Sequence: string;
  MatchRuleLabel: string;
  HyphenClass: string;
  PremiseNumber: string;
  SubBuildingNumber: string;
  Country: string;
};

export type LoqateVerifyResponse = {
  isVerified: boolean;
  score: number;
  suggestions: LoqateVerifyMatch[];
  addressType: "billing" | "shipping";
};

export type UseLoqateReturn = {
  setCountryCode: (countryCode: string) => void;
  searchTerm: Record<string, string>;
  updateSearchTerm: (name: string, value: string) => void;
  activeLookupField: string | undefined;
  suggestions: FindItem[];
  setSuggestions: (suggestions: FindItem[]) => void;
  isLoading: boolean;
  error: string | null;
  setActiveContainer: (container: string | undefined) => void;
  retrieveAddress: (name: string, id: string) => Promise<RetrieveItem | null>;
  verifyAddress: (Addresses: VerifyAddressInput[]) => Promise<LoqateVerifyResponse[] | null>;
  isVerifying: boolean;
  setIsVerifying: (isVerifying: boolean) => void;
  suggestionModalData: LoqateVerifyResponse[] | null;
  setSuggestionModalData: (data: LoqateVerifyResponse[] | null) => void;
  bypassValidation: boolean;
  setBypassValidation: (bypass: boolean) => void;
  applySuggestion: (
    suggestion: LoqateVerifyMatch,
    addressType: "billing" | "shipping"
  ) => void;
};
